import {
  useDeleteWatchTrip,
  type UseDeleteTripWatchTripReturn,
} from "@apac/price-watch";
import { logger } from "@hopper-b2b/datadog";

export type UnwatchTripResponse = unknown;

export interface UseUnwatchTripFormReturn {
  context: UseDeleteTripWatchTripReturn["context"];
  handlers: {
    onUnwatchTripSubmit: () => Promise<unknown>;
  };
}

export const useUnwatchTripForm = ({
  flightKey,
  onSubmit,
  onSuccess,
  onError,
}: {
  flightKey;
  onSubmit?: () => void;
  onSuccess?: (response: UnwatchTripResponse) => unknown;
  onError?: (error: unknown) => unknown;
}): UseUnwatchTripFormReturn => {
  const {
    context,
    handlers: { unwatch },
  } = useDeleteWatchTrip({ flightKey });

  return {
    context,
    handlers: {
      onUnwatchTripSubmit: async () => {
        onSubmit?.();
        try {
          const response = await unwatch();
          await onSuccess?.(response);

          return response;
        } catch (error) {
          logger().error("Error in unwatch trip request: ", { error });
          onError?.(error);
        }
      },
    },
  };
};
